import { USER_DETAILS } from "../Actions/actions";


const initialState = {
    authData: []
};

export const AuthenticationReducer = (state: any = initialState, action: any) => {

    switch (action.type) {
    case USER_DETAILS:
        return {
            ...state,
            authData: action.payload
        };
    default:
        return state;
    }
};
